export { default as component } from "../../../../src/routes/[prefix]/(feature)/customer/+page.svelte";